/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Layout } from "antd";
import { Listing } from "./components/Listing";
import { useSelector } from "react-redux";
import { Suggestions } from "./components/Suggestions";
import styles from "./styles/TestingRoute.module.css";
import { Support } from "./components/Support";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { bugReportHandle } from "./state/actions";
import { getValuesFromUrl } from "../Common/utils/extraFunctions";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";

const { Content } = Layout;

function BugReportHome() {
  const { renderComp, searchbugdata } = useSelector((state) => state.bugReport);
  const isMobile = useMediaQuery({ maxWidth: 985 });
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const param = new URLSearchParams(window.location.search);
  const idValue = getValuesFromUrl(param.get("id"));
  const { ticketNo } = useParams();
  const urlType = param.get("type");
  const searchType = searchbugdata?.[0]?.type;
  const type = searchType || urlType;

  useEffect(() => {
    if (searchType && searchType !== urlType) {
      if (isMobile) {
        const mobileRoute = searchType === "SUGGESTIONS" ? "/suggestions" : searchType === "SUPPORT" ? "/mobilesupport" : "/bugsReport";
        history.replace(mobileRoute + `?type=${searchType}`);
      } else {
        param.set("type", searchType);
        history.replace({ pathname: "/bugsReport", search: param.toString() });
      }
    }
  }, [searchType, urlType, history, location.pathname, param]);

  useEffect(() => {
    if (ticketNo?.length) {
      dispatch(bugReportHandle.searchbug(ticketNo, null, "URL_REDIRECT"));
    }
  }, [ticketNo]);

  useEffect(() => {
    if (type?.length) {
      if (type === "BUGS") {
        dispatch(bugReportHandle.renderComponant("listings"));
      } else if (type === "SUGGESTIONS") {
        dispatch(bugReportHandle.renderComponant("suggestions"));
      } else {
        dispatch(bugReportHandle.renderComponant("support"));
      }
    } else {
      if (location?.pathname === "/bugsReport") {
        dispatch(bugReportHandle.renderComponant("listings"));
      } else if (location?.pathname === "/suggestions") {
        dispatch(bugReportHandle.renderComponant("suggestions"));
      } else if (location?.pathname === "/mobilesupport") {
        dispatch(bugReportHandle.renderComponant("support"));
      }
    }
  }, [location, type, dispatch]);

  console.log("type", type, renderComp);

  return (
    <Layout style={{ height: "100%", padding: "0" }}>
      <Content
        style={{
          width: "100%",
          marginTop: "20px",
          padding: "1rem",
          height: "85vh",
        }}
      >
        <div
          className={styles.contentWrapper}
          style={{
            display: "flex",
            justifyContent: "center",
            margin: isMobile ? "" : "0 -20px 0 -20px",
          }}
        >
          {renderComp === "listings" ? <Listing idValue={idValue} /> : renderComp === "suggestions" ? <Suggestions idValue={idValue} /> : renderComp === "support" ? <Support idValue={idValue} /> : <Listing idValue={idValue} />}
        </div>
      </Content>
    </Layout>
  );
}

export { BugReportHome };
